module.exports = __webpack_public_path__ + "static/media/ShopMart.44bf521c.png";